import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/img01.png';
import 'animate.css/animate.min.css';

export default function Agile() {
    return (
        <Container className='mt-5 agile'>
            <Row>
                <div className='responsive-title'>Agile by Nature. Strategic by Design.</div>
                <div className='responsive-title'>Scalable by Impact.</div>
            </Row>
            <Row className='mt-4'>
                <Col xs={12} md={6} className='mb-6'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={0.5} offset={100}>
                        <div className='hover-zoom bg-white'>
                            <img src={img01} alt="" style={{ borderRadius: '25px', width: '100%' }} />
                        </div>
                    </AnimationOnScroll>
                </Col>
                <Col xs={12} md={6} className='mb-6'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={0.5} offset={100}>
                        <div className='hover-zoom bg-white text' style={{ padding: '10px' }}>
                            <p className='mb-3'>At Exel, we don't just deliver IT. We engineer tailored digital ecosystems that evolve with your business. Whether you're a fast-scaling startup, a data-heavy enterprise, or a retail disruptor, we adapt at the speed of your ambition.</p>
                            <p className='mb-3'>Our solutions are designed to eliminate friction, amplify efficiency, and create sustainable value across infrastructure, security, commerce, and customer engagement. With a cross-industry approach and deep tech capabilities, Exel empowers you to move faster, think bigger, and build smarter in a constantly shifting digital landscape.</p>
                            <p className='mb-3'>Because in a world of rapid disruption, you don't just need a vendor. You need a transformation partner.</p>
                        </div>
                    </AnimationOnScroll>
                </Col>
            </Row>
        </Container>
    );
}
